export const HOST = 'https://pincode-dev.ru/pp-manager/api';
// export const HOST = 'http://localhost:5000/api';
